import React from "react";
import logo from './images/logo.png';
import Footer from './footer';
import mail from './images/mail.png';
import phone from './images/phone.png';

async function submitContact() {
  let mod = document.getElementById("contactMod");
  mod.style.display = "block"
}

export default function Home(){ 
  return (
    <>
    <div style={{textAlign: "center", marginBottom: "50px"}}>
          <img src={logo} id="homelogo" alt="" width="40%"/>
          <div>Family Owned and Operated full service IT development and design agency located in Bay City Michigan.<br/>Let us help bring your ideas to life! We offer competitive One-Off and Contract pricing for anything from a simple logo design, to a fully responsive site build/refresh, to a full system build to help you manage and operate your business! 
          <div style={{marginTop: "30px"}}>Please contact us below for more information!</div>
          <div id="contact" style={{marginTop: "30px"}}>
            <img className="img1" src={mail} width="50px" alt="" onClick={submitContact}/>
            <a href="tel:+1-989-891-7896"><img className="img1" src={phone} style={{marginLeft: "10px", width: "50px", borderRadius: "10px"}} alt="" /></a>
          </div>
            <div style={{marginTop: "50px"}}>
              <li>Website Build, Redesign</li>
              <li>Web Hosting</li>
              <li>Full Stack Application Build</li>
              <li>Development Consulting</li>
              <li>API Services</li>
              <li>Logo Design</li>
            </div>
          </div>
    </div>
    <Footer />
    </>
  );  
}